<template>
  <div class="content-warp">
    <div class="content-panle bg-white" style="position:relative">
      <div class="table-operation-area">
        <div class="btn-area-inline">
          <a-button type="primary" @click="() => addModalVisible = true">{{$t('timeConfig.addBtn')}}</a-button>
        </div>
        <a-form class="search-form" layout="inline" :form="listSearchForm" @submit.prevent="() => getTimeConfig()">
          <a-form-item>
            <a-input 
              style="width: 350px"
              type="text"
              v-decorator="['searchName']" 
              :placeholder="$t('timeConfig.searchTxt')" >
              <a-icon slot="prefix" type="clock-circle" style="color:rgba(0,0,0,.25)" />
            </a-input>
          </a-form-item>
          <a-form-item>
            <a-button type="primary" html-type="submit" :loading="loading">
              {{$t('timeConfig.searchBtn')}}
            </a-button>
          </a-form-item>
        </a-form>
      </div>

      <TableTips :total="pagination.total" />

      <a-table 
        class="table-area"
        :columns="tableColumns" 
        :dataSource="tableData"
        :pagination="pagination"
        :loading="loading"
        @change="handleTableChange"
        @expand="handleTableExpand"
        :expandedRowKeys="expandedRowKeys"
      >  
        <!-- 名称 -->
        <template slot="name" slot-scope="text, record">
          <div v-if="text.edit">
            <a-input
              style="margin: -5px 0"
              :ref="`input-${record.id}`"
              :default-value="text.content"
              @change="e => handleNameValidate(record, e)"
              @blur="e => text.edit = false"
              @keyup.enter="e => handleSubmitName(record, e)"
            />
            <div v-if="text.error" style="margin-top: 5px;color: #f5222d">{{ text.error }}</div>
          </div>          
          <span v-else class="period-name" @dblclick="()=> handleOpenNameEdit(record)">{{ text.content }}</span>
        </template>
        <!-- 状态 -->
        <template slot="state" slot-scope="text, record">
          <a-switch 
            :checked-children="$t('timeConfig.tableOpen')" 
            :un-checked-children="$t('timeConfig.tableDisabled')" 
            :checked="text" 
            @change="val => handelStateChange(record, val)" 
          />
        </template>
        <!-- 操作 -->
        <template slot="operation" slot-scope="text, record">
          <div v-if="!record.isDefault">
            <a 
              class="operation-botton" 
              v-for="item in record.operation" 
              :key="item.type"
              :disabled="item.disabled"
              :style="{color: item.color, 'word-break': 'keep-all'}"
              @click="item.callback(record)"
            >{{ $t(item.type) }}</a>
          </div>
          <div v-else>--</div>
        </template>
        <!-- 展开项 -->
        <a-row :gutter="24" slot="expandedRowRender" slot-scope="record">
          <!-- 时间配置详情 -->
          <a-col :span="12">
            <h4 class="panle-head">{{$t('timeConfig.tableSetDetail')}}</h4>
            <a-table
              :columns="innerTimeColumns"
              :data-source="record.times"
              :pagination="false"
              :loading="innerLoading"
              :scroll="{ y: 450 }"
            > 
              <template slot="week" slot-scope="text, record">
                <span>{{$t(text)}}</span>
              </template>
              <template slot="time" slot-scope="text, record">
                <div v-if="text.length" class="inner-table-times">
                  <span 
                    v-for="(time, index) in text" 
                    :key="index"
                  >{{time.fromTime}} ~ {{time.toTime}}</span>
                </div>
                <span v-else>--</span>
              </template>
            </a-table>
          </a-col>
          <!-- 已授权设备 -->
          <a-col :span="12">
            <h4 class="panle-head">{{$t('timeConfig.tableAuthedDevice')}}</h4>
            <a-table
              :columns="innerDeviceColumns"
              :data-source="record.devices"
              :pagination="false"
              :loading="innerLoading"
              :scroll="{ y: 450 }"
            ></a-table>
          </a-col>
        </a-row>
      </a-table> 

      <!-- <div style="height:50px;background-color:#eee;position: absolute;bottom: 100px;left: 0;right:0">
        <TimeBar 
          :times="timeBarData"
          :extend="50"
          @change="times => timeBarData = times"
        />
      </div> -->
    </div>

    <!-- 新增时间段态框 -->
    <a-modal
      :title="$t('timeConfig.addTitle')"
      :okText="$t('timeConfig.saveBtn')"
      :cancelText="$t('timeConfig.cancelBtn')"      
      :visible="addModalVisible"
      :confirmLoading="confirmLoading"      
      @ok="handleAddConfig"      
      @cancel="() => addModalVisible = false"
      :afterClose="handleHideAddModal"
    > 
      <a-form-model 
        ref="addConfigForm"
        :model="addConfigForm" 
        :rules="addConfigFormRules"
        :label-col="{ span: 6 }" 
        :wrapper-col="{ span: 18 }" 
      >
        <a-form-model-item required :label="$t('timeConfig.addConfigName')" prop="name">
          <a-input 
            v-model="addConfigForm.name"
            :placeholder="$t('timeConfig.addConfigNameTxt')"
          />
        </a-form-model-item>
      </a-form-model>
    </a-modal>

    <!-- 授权模态框 -->
    <AuthTreeModal 
      v-if="authModalVisible"
      :id="targetConfigId"
      @close="handleCloseAuthTreeModal"
    />

    <!-- 时间设置模态框 -->
    <SetTimeModal 
      v-if="setTimeModalVisible"
      :id="targetConfigId"
      :configSource="targetConfig"
      @close="handleCloseSetTimeModal"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import TableTips from '@/components/TableTips';
// import TimeBar from './components/TimeBar';
import AuthTreeModal from './components/AuthTreeModal';
import SetTimeModal from './components/SetTimeModal';

import { 
  getAllTimeConfig, 
  getDevicesByTimeConfig,
  createTimeConfig,
  modifyTimeConfig,
  modifyTimeConfigState,
  deleteTimeConfig
} from '@/api/timeConfig';

const weekLangStr = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];

export default {
  name: 'timeConfigIndex',
  components: { TableTips, AuthTreeModal, SetTimeModal },
  data () {
    return {
      // timeBarData: [{ fromTime: '00:30:00', toTime: '01:00:00' }, { fromTime: '08:40:00', toTime: '12:00:00' }, { fromTime: '22:30:00', toTime: '23:00:00' }],

      listSearchForm: this.$form.createForm(this),
      
      loading: false, // 列表内容是否在加载中
      // nameEditing: false,
      tableData: [], // 列表数据源
      tableColumns: this.createTableColumns(), // 列表表头项
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0
      },
      expandedRowKeys: [],
      innerDeviceColumns: this.createInnerDeviceColumns(),
      innerTimeColumns: this.createInnerTimeColumns(),
      innerLoading: false,

      // 添加设备
      addModalVisible: false,
      confirmLoading: false,
      addConfigForm: {
        name: ''
      },
      addConfigFormRules: this.getAddConfigFormRules(),

      // 授权门禁模态框
      authModalVisible: false,
      // 时间设置模态框
      setTimeModalVisible: false,
      // 目标时间配置 ID
      targetConfigId: '',
      // 目标时间配置
      targetConfig: null
    }
  },
  computed: {
    ...mapState(['lang'])
  },
  created() {
    this.getTimeConfig()
  },
  watch: {
    lang: function (lang) {
      this.tableColumns = this.createTableColumns()
      this.innerDeviceColumns = this.createInnerDeviceColumns()
      this.innerTimeColumns = this.createInnerTimeColumns()
      this.addConfigFormRules = this.getAddConfigFormRules()
    }
  }, 
  methods: {
    // 创建列表表头
    createTableColumns() {
      return [
        {
          title: this.$t('timeConfig.tableName'),
          dataIndex: 'name',
          width: '50%',
          scopedSlots: { customRender: 'name' }
        },
        {
          title: this.$t('timeConfig.tableState'),
          dataIndex: 'state',
          width: '20%',
          scopedSlots: { customRender: 'state' }
        }, {
          title: this.$t('timeConfig.tableOpera'),
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' }
        }
      ]
    },
    // 创建列表展开项-已授权设备列表表头
    createInnerDeviceColumns() {
      return [
        {
          title: this.$t('timeConfig.tableDeviceName'),
          dataIndex: 'deviceName',
          width: '40%'
        },
        {
          title: this.$t('timeConfig.tableDeviceBelong'),
          dataIndex: 'deptFullName'
        }
      ]
    },
    // 创建列表展开项-时间配置详情列表表头
    createInnerTimeColumns() {
      return [
        {
          title: this.$t('timeConfig.tableWeek'),
          dataIndex: 'week',
          width: '18%',
          scopedSlots: { customRender: 'week' }
        },
        {
          title: this.$t('timeConfig.tableSetted'),
          dataIndex: 'time',
          scopedSlots: { customRender: 'time' }
        }
      ]
    },
    
    // 提交添加时间段名
    handleAddConfig(e) {
      this.$refs.addConfigForm.validate(async valid => {
        if (valid) {
          try {
            this.confirmLoading = true;
            await createTimeConfig({
              name: this.addConfigForm.name,
              times: { times1: [], times2: [], times3: [], times4: [], times5: [], times6: [], times7: [] }
            })
            this.addModalVisible = false
            this.confirmLoading = false
            this.getTimeConfig(this.pagination.current)
          } catch (error) {
            this.confirmLoading = false;
          }
        }
      })
    },
    // 新增模态框 Form 验证
    getAddConfigFormRules() {
      return {
        name: [
          { required: true, message: this.$t('timeConfig.configNameBlank'), trigger: ['blur', 'change'] },
          { max: 20, message: this.$t('timeConfig.configNameWarning'), trigger: 'change' }
        ]
      }
    },
    // 隐藏新增模态框
    handleHideAddModal() {
      this.$refs.addConfigForm.resetFields();
      this.confirmLoading = false;
    },

    // 搜索\获取时间段列表数据
    getTimeConfig(page = 1) {
      this.listSearchForm.validateFields(async (err, values) => {
        if (!err) {
          this.pagination.current = page
          try {
            this.loading = true;
            const { data } = await getAllTimeConfig({
              perPage: this.pagination.pageSize,
              page: this.pagination.current,
              name: values.searchName && values.searchName.trim()
            })
            this.loading = false;
            // console.log('-getTimeConfig-', data)
            this.pagination.total = data.size;

            this.tableData = this.createTimeConfigTable(data.collection);            
          } catch (error) {
            this.loading = false
          }
        }
      });
    },
    // 创建表格数据
    createTimeConfigTable(data) {
      return data.map(item => {
        return {
          key: item.id,
          id: item.id,
          isDefault: item.isDefault,
          name: {
            content: item.name,
            edit: false,
            error: ''
          },
          state: item.state === 0, // 0：开启；1：关闭；2：删除
          operation: [{
            type: 'timeConfig.setBtn',
            disabled: false,
            color: '#1890ff',
            callback: record => { 
              this.setTimeModalVisible = true
              this.targetConfigId = record.id
              this.targetConfig = item
            }
          }, {
            type: 'timeConfig.authBtn',
            disabled: false,
            color: '#fa8c16',
            callback: record => { 
              this.authModalVisible = true
              this.targetConfigId = record.id
            }
          }, {
            type: 'timeConfig.deleteBtn',
            disabled: false,
            color: '#f5222d',
            callback: this.showDeleteWarning
          }],
          times: this.createInnerTimes(item.times),
          devices: []
        }
      })
    },
    // 创建展开项-时间配置详情表格数据
    createInnerTimes(data) {
      const times = []
      Object.keys(data).forEach((key, index) => {
        const timeItem = { key, week: 'timeConfig.' + weekLangStr[index], time: data[key] }
        timeItem.time = timeItem.time.map(val => {
          // if (val.toTime === '00:00:00') val.toTime = '23:59:59'
          return val
        })
        times.push(timeItem)
      })
      return times
    },

    // 点击分页时触发
    handleTableChange(pagination, filters, sorter) {
      // this.pagination.current = pagination.current
      this.getTimeConfig(pagination.current)
    },
    // 表格行展开
    async handleTableExpand(expanded, tebleItem) {
      // console.log('-handleTableExpand-', expanded, tebleItem)
      if (expanded) {
        this.expandedRowKeys = [tebleItem.key]
        try {
          this.innerLoading = true
          const { data } = await getDevicesByTimeConfig(tebleItem.id) 
          tebleItem.devices = data.collection.map(device => ({ ...device, key: device.deviceId }))
          this.innerLoading = false
        } catch (error) {
          this.innerLoading = false
        }
      } else {
        this.expandedRowKeys = []
      }
    },

    // 打开时间配置名称编辑
    handleOpenNameEdit(tableItem) {
      if (!tableItem.isDefault) {
        tableItem.name.edit = true
        setTimeout(() => {
          this.$refs[`input-${tableItem.id}`].focus()
        }, 50)
      }
    },
    // 时间配置名称项输入框内容变化时
    handleNameValidate(tableItem, e) {
      const val = e.target.value
      if (val) {
        if (val.length > 20) {
          tableItem.name.error = this.$t('timeConfig.configNameWarning')
          return false
        }
        tableItem.name.error = ''
        return true
      } else {
        tableItem.name.error = this.$t('timeConfig.configNameBlank')
        return false
      }
    },
    // 时间配置名称提交修改
    async handleSubmitName(tableItem, e) {
      if (this.handleNameValidate(tableItem, e) && e.target.value !== tableItem.name.content) {
        try {
          this.$message.loading(this.$t('timeConfig.nameChanging'), 0)
          const data = { id: tableItem.id, name: e.target.value, times: {} }
          tableItem.times.forEach((item, index) => {
            data.times[`time${index + 1}`] = item.time
          })
          await modifyTimeConfig(data)
          tableItem.name.content = e.target.value
          this.$message.destroy()
          e.target.blur()
        } catch (error) {
          this.$message.destroy()
        }
      } else {
        e.target.blur()
      }
    },

    // 时间配置状态项变化时
    async handelStateChange(tableItem, val) {
      try {
        this.$message.loading(this.$t('timeConfig.stateChanging'), 0)
        await modifyTimeConfigState({
          id: tableItem.id,
          state: val ? 0 : 1
        })
        tableItem.state = val
        this.$message.destroy()
      } catch (error) {
        this.$message.destroy()
      }
    },

    // 删除时间配置警告
    showDeleteWarning(tableItem) {
      this.$confirm({
        title: this.$t('timeConfig.deleteTipTitle'),
        content: this.$t('timeConfig.deleteTipContent'),
        okText: this.$t('timeConfig.comfirmBtn'),
        cancelText: this.$t('timeConfig.cancelBtn'),
        onOk: () => { this.deleteTimeConfig(tableItem.id) },
        onCancel() {}
      });
    },
    // 删除时间配置
    async deleteTimeConfig(id) {
      try {
        this.$message.loading(this.$t('timeConfig.deletingConfig'), 0)
        await deleteTimeConfig(id)
        this.$message.destroy()
        this.getTimeConfig(this.pagination.current)
      } catch (error) {
        this.$message.destroy()
      }
    },
    
    handleCloseAuthTreeModal(data = {}) {
      if (data.refreshList) {
        this.expandedRowKeys = []
        this.getTimeConfig(this.pagination.current)
      }
      this.authModalVisible = false
    },
    handleCloseSetTimeModal(data = {}) {      
      if (data.refreshList) {
        this.expandedRowKeys = []
        this.getTimeConfig(this.pagination.current)
      }
      this.setTimeModalVisible = false
    }
  }
}
</script>

<style lang="less" scoped>
.period-name{
  display: block;
  width: 100%;
  cursor: pointer
}
.inner-table-times{
  display:flex;
  flex-wrap: wrap;

  span {
    margin: 0 10px
  }
}
</style>
